import { AxiosPromise } from 'axios'
import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { cookRequestParams } from '@/common/request'
import type {
  GetAssetListParams,
  GetLabelAllParams,
  AssetListModel,
  FromModelType,
  GetUpdateAssetParams,
} from './type'

// 资源标签
export function getAssetTagList(params?: GetLabelAllParams): AxiosPromise {
  return request({
    url: v2Host + '/asset/tag-group/list-all',
    method: 'get',
    params,
  })
}

// 资源列表
export function getAssetList(
  params: GetAssetListParams,
): AxiosPromise<AssetListModel> {
  return request({
    url: v2Host + '/asset/list',
    method: 'get',
    params: cookRequestParams(params),
  })
}

// 删除资源
export function delAsset(data: { ids: string }): AxiosPromise {
  return request({
    url: v2Host + '/asset/del',
    method: 'post',
    data: data,
  })
}

// 新增、编辑资源
export function saveAsset(data: FromModelType): AxiosPromise {
  return request({
    url: v2Host + '/asset/save',
    method: 'post',
    data: data,
  })
}

// 批量操作
export function updateAsset(data: GetUpdateAssetParams): AxiosPromise {
  return request({
    url: v2Host + '/asset/update',
    method: 'post',
    data: data,
  })
}

// 资源下载
export function downloadAsset(data: {
  ids: string
  replace?: number
}): AxiosPromise {
  return request({
    url: v2Host + '/asset/download',
    method: 'post',
    data: data,
  })
}

// 批量上传
export function batchCreateAsset(data: {
  type: string
  assets: string
}): AxiosPromise {
  return request({
    url: `${v2Host}/asset/batch-create`,
    method: 'post',
    data: data,
  })
}
